import axios from 'axios';

import { Picture } from './types';

export type FetchNearbyCitiesParams = {
  city: string;
  withDelivery: boolean;
};

export type CitiesResponse = {
  cities: CityResponse[];
};

export type CityResponse = {
  id: string;
  existingPlaceId?: string;
  slug: string;
  name: string;
  displayName: string;
  location: {
    lat: number;
    lng: number;
  };
  distance?: number;
  weight?: number;
  description?: string;
  picture?: Picture;
  partner?: string;
  partnerId?: string;
};

export type FetchAutocompleteCityParams = {
  search: string;
  sessionToken?: string;
  limit?: number;
  lat?: number;
  lng?: number;
  withoutParis?: boolean;
  withPartner?: boolean;
};

export const fetchCityRequest = async (slug: string): Promise<CityResponse> => {
  const { data } = await axios.get<{ city: CityResponse }>(`/city/${slug}`);
  return data.city;
};

export const fetchNearbyCitiesRequest = async ({ city, withDelivery }: FetchNearbyCitiesParams): Promise<CityResponse[]> => {
  const { data } = await axios.get<CitiesResponse>(`/city/${city}/closest?limit=7&withDelivery=${withDelivery}`);
  return data.cities;
};

export const fetchAutocompleteCityRequest = async (params: FetchAutocompleteCityParams): Promise<CityResponse[]> => {
  const { data } = await axios.get<CitiesResponse>(`/city/autocomplete`, {
    params: {
      search: params.search,
      withPartner: params.withPartner ?? true,
      limit: params.limit,
      lat: params.lat,
      lng: params.lng,
      withoutParis: params.withoutParis,
      sessionToken: params.sessionToken
    }
  });
  return data.cities;
};

export const fetchAutocompleteCityGmapRequest = async ({
  search,
  sessionToken,
  limit,
  lat,
  lng,
  withoutParis
}: FetchAutocompleteCityParams): Promise<CityResponse[]> => {
  const params = {
    search,
    sessionToken,
    limit,
    location: lat && lng ? { lat, lng } : undefined,
    withoutParis
  };
  const { data } = await axios.get<CitiesResponse>(`/city/autocomplete/gmap`, { params });
  return data.cities;
};
